import React, { useContext } from 'react';
import { AuthContext } from '../../../context/auth';
import Header from '../../../components/Header';
import Barra from '../../../components/barra';
import MenuInmueblesUrbanos from '../../../components/hacienda/inmueblesUrbanos/menuInmueblesUrbanos';
import TablaInmueble from '../../../components/hacienda/inmueblesUrbanos/tablaInmuebles';
import imagen from '../../../imagenes/inmuebles.png';
import Footer from '../../../components/Footer';
import MenuPrincipalInmueble from '../../../components/hacienda/inmueblesUrbanos/menuPrincipalInmueble';



function InmueblesUrbanos() {

  let op = require('../../../../src/modulos/datos');
  const { user } = useContext(AuthContext);
  let per = JSON.parse(localStorage.getItem('permisos'));

  return (

    user && (
      <div style={{ height: "100vh", padding: 0 }}>
        <div  className="col-md-12" style={{ height: "95%", padding: 0 }}>
           <MenuPrincipalInmueble/>
        </div>
        <div  className="col-md-12" style={{ height: "5%", padding: 0 }}>
           <Footer />
        </div>

      </div>

    )


  );
}


export default InmueblesUrbanos;
